/**
 * Do not edit directly
 * Generated on Fri, 11 Nov 2022 09:04:27 GMT
 */

module.exports = {
  'actual-dd-gold': '#b09471ff',
  'progressive-blue': '#003057ff',
  'natural-cream': '#efe2d6ff',
  '10-black-on-natural-cream': '#d7cbc1ff',
  white: '#ffffffff',
  'light-grey-1': '#ddddddff',
  'light-grey-2': '#999999ff',
  'body-text-grey': '#555555ff',
  'off-black': '#252525ff',
  '40-white-on-dark-blue': '#66839aff',
  '80-white-on-dark-blue': '#ccd6ddff',
  'quality-gold': 'linear-gradient(315deg, #9D815B 0%, #B09471 43.23%, #E5C794 100%)'
};
